import React from 'react';
import { LegalPage } from '../landing/LegalPage';

export function TermsView() {
    return <LegalPage kind="terms" />;
}
